import React from "react";

const UserNetworkMenuIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="user-network-menu-icon"
  >
    <g className="user-network-menu-icon__outline">
      <path
        d="M9.16006 10.87C9.06006 10.86 8.94006 10.86 8.83006 10.87C6.45006 10.79 4.56006 8.84 4.56006 6.44C4.56006 3.99 6.54006 2 9.00006 2C11.4501 2 13.4401 3.99 13.4401 6.44C13.4301 8.84 11.5401 10.79 9.16006 10.87Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.41 4.05C18.35 4.05 19.91 5.61 19.91 7.55C19.91 9.47 18.41 10.98 16.51 11.05C16.46 11.04 16.39 11.04 16.33 11.05"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16 14.56C1.75 16.08 1.75 18.52 4.16 20.03C6.91 21.79 11.42 21.79 14.17 20.03C16.58 18.51 16.58 16.07 14.17 14.56C11.43 12.81 6.92 12.81 4.16 14.56Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.34 20C19.06 19.85 19.74 19.56 20.3 19.13C21.86 17.96 21.86 16.03 20.3 14.86C19.75 14.44 19.08 14.16 18.37 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g className="user-network-menu-icon__filled">
      <path
        d="M9.16 11.8701C9.06 11.8601 8.94 11.8601 8.83 11.8701C6.45 11.7901 4.56 9.84006 4.56 7.44006C4.56 4.99006 6.54 3.00006 9 3.00006C11.46 3.00006 13.44 4.99006 13.44 7.44006C13.43 9.84006 11.54 11.7901 9.16 11.8701Z"
        fill="currentColor"
      />
      <path
        d="M16.34 5.81006C17.56 6.07006 18.46 7.20006 18.46 8.55006C18.46 9.65006 17.87 10.6201 17 11.1601C16.88 8.87006 16.52 6.58006 16.34 5.81006Z"
        fill="currentColor"
      />
      <path
        d="M4.16 15.5601C1.75 17.0801 1.75 19.5201 4.16 21.0301C6.91 22.7901 11.42 22.7901 14.17 21.0301C16.58 19.5101 16.58 17.0701 14.17 15.5601C11.43 13.8101 6.92 13.8101 4.16 15.5601Z"
        fill="currentColor"
      />
      <path
        d="M18.34 20.5C19.01 20.36 19.66 20.08 20.19 19.68C21.64 18.58 21.64 16.72 20.19 15.62C19.67 15.23 19.03 14.95 18.37 14.73C19.71 16.02 20.57 17.68 20.57 19.5C20.57 19.83 20.54 20.15 20.5 20.46C19.82 20.66 19.09 20.63 18.34 20.5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default UserNetworkMenuIcon;
